export enum TemplateName {
  TRIP_OVERVIEW = 'overview'
}
